import { getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  vehicleAndDriver: null,
  stepCompleted: false,
  otherDriversLicenseFile: null,
  deleteOtherDriverLicenseResponse: null,
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_VEHICLE_AND_DRIVER': {
      return {
        ...state,
        vehicleAndDriver: action.payload.vehicleAndDriver,
        stepCompleted: true,
      }
    }

    case 'OTHER_DRIVERS_LICENSE_ADD': {
      return {
        ...state,
        otherDriversLicenseFile: action.payload.file || null,
      }
    }

    case 'OTHER_DRIVERS_LICENSE_REMOVE' : {
      return {
        ...state,
        deleteOtherDriverLicenseResponse: {},
      }
    }
    case 'OTHER_DRIVERS_LICENSE_REMOVE_COMMIT' : {
      return {
        ...state,
        deleteOtherDriverLicenseResponse: {
          success: true,
        },
      }
    }
    case 'OTHER_DRIVERS_LICENSE_REMOVE_ROLLBACK' : {

      const isFileNotFound = action.payload && action.payload.response &&
        action.payload.response.status && action.payload.response.status === 404

      return {
        ...state,
        // If we got response that file is not found, we can clear it from redux state
        otherDriversLicenseFile: isFileNotFound ? null : state.otherDriversLicenseFile,
        deleteOtherDriverLicenseResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'OTHER_DRIVERS_LICENSE_CLEAR': {
      return {
        ...state,
        otherDriversLicenseFile: null,
      }
    }

    default: {
      return state
    }
  }
}
